import { Col, Row, Typography } from "antd";
import { Formik } from "formik";
import * as Yup from "yup";
import { Form, FormItem, Checkbox } from "formik-antd";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import * as consultantReducer from "../Redux/Consultant/reducer";
import {
  FormikEmailInput,
  FormikInput,
  FormikPassword,
  SelectCountry,
  FormikSubmitButton,
} from "../FormItems";
import ImageComponent from "../Utilities/ImageComponent";
import { StyledLink, SocialButton } from "../styled-components/components";
import Feedback from "../Utilities/Feedback";
import { useHistory } from "react-router";
import constants from "../Redux/constants";
import { useGoogleLogin } from "react-google-login";
import {
  googleAuthentication,
  getLinkedInAcessToken,
} from "../Redux/User/reducer";
import { LoadingOutlined } from "@ant-design/icons";
import google from "../../images/google.svg";
import linkedIn from "../../images/linkedin.svg";
import moment from "moment";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  mobileNumber: "",
  country: "",
  password: "",
  termsAndConditions: false,
  marketingOptIn: true,
};

const validationSchema = Yup.object().shape({
  firstName: Yup.string().required("First name is required"),
  lastName: Yup.string().required("Last name is required"),
  email: Yup.string().email().required("Email is required"),
  mobileNumber: Yup.string().required("Phone Number is Required"),
  country: Yup.string().required("Country is required"),
  password: Yup.string()
    .required("Password is required")
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
    ),
  termsAndConditions: Yup.bool().oneOf([true], ""),
  marketingOptIn: Yup.bool().oneOf([true], ""),
  timeZone: Yup.string().optional(),
});

const RegistrationForm = (props) => {
  const history = useHistory();
  const [countryCode, setCountryCode] = useState("+00");
  const [isRegistered, setIsRegistered] = useState(false);
  const [loader, setLoader] = useState(false);
  // consultant sign up
  const registerUser = async (formValues, actions) => {
    formValues.mobileNumber = `${countryCode} ${formValues.mobileNumber}`;
    formValues.timeZone = moment(new Date()).format("Z");
    const { responseStatus } = await props.signUpConsultant(formValues);
    if (responseStatus === constants.status.created) {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
      setIsRegistered(true);
      setTimeout(() => {
        history.push("/consultant/home");
      }, 2500);
    } else if (responseStatus === constants.status.conflict) {
      actions.setErrors({ email: "Email is already Registered" });
      actions.setSubmittng(false);
    }
  };
  const getCountryCode = (value) => {
    setCountryCode(value);
  };
  // google sign up
  const responseGoogle = async (res) => {
    const token = res.tokenObj.id_token;
    if (token) {
      setLoader(true);
      const role = constants.roles.consultant;
      await props.googleAuthentication(token, role);
      history.push("/consultant/home");
    }
  };
  // linked in sign up
  useEffect(() => {
    const popupWindowURL = new URL(window.location.href);
    const code = popupWindowURL.searchParams.get("code");
    localStorage.setItem("code", code);
    window.close();
  }, []);
  const handleLinkedIn = async () => {
    const accessCode = localStorage.getItem("code");
    if (accessCode) {
      setLoader(true);
      const role = constants.roles.consultant;
      await props.getLinkedInAcessToken(
        process.env.REACT_APP_LINKED_REDIRECT_CONSULTANT_URL,
        accessCode,
        role
      );
      history.push("/consultant/home");
    }
  };
  useEffect(() => {
    window.addEventListener("storage", handleLinkedIn);
    return () => {
      window.removeEventListener("storage", handleLinkedIn);
    };
  });
  const responseLinkedIn = async () => {
    const oauthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${process.env.REACT_APP_LINKED_IN_CLIENT_ID}&scope=r_liteprofile%20r_emailaddress&state=123456&redirect_uri=${process.env.REACT_APP_LINKED_REDIRECT_CONSULTANT_URL}`;
    const width = 450,
      height = 730,
      left = window.screen.width / 2 - width / 2,
      top = window.screen.height / 2 - height / 2;

    window.open(
      oauthUrl,
      "Linkedin",
      "menubar=no,location=no,resizable=no,scrollbars=no,status=no, width=" +
        width +
        ", height=" +
        height +
        ", top=" +
        top +
        ", left=" +
        left
    );
  };
  // component
  return (
    <Col xs={{ span: 24 }}>
      <Row>
        <ImageComponent height="120vh" />
        <Col
          xs={{ span: 24 }}
          md={{ span: 14 }}
          lg={{ span: 12 }}
          xl={{ span: 9 }}
          xxl={{ span: 8 }}
          style={{ padding: "1vh", marginLeft: "auto", marginRight: "auto" }}
        >
          {loader ? (
            <Col>
              <Feedback
                icon={<LoadingOutlined />}
                title="Signing Up"
                subTitle="Redirect to home page"
              ></Feedback>
            </Col>
          ) : (
            <Col>
              {isRegistered ? (
                <Col xs={{ span: 24 }} xl={{ span: 12 }}>
                  <Feedback
                    status="success"
                    title="Registered Successfully"
                    subTitle="Re-directing to homepage"
                  />
                </Col>
              ) : (
                <Col>
                  <Col xs={{ span: 24 }}>
                    <Row justify="space-between">
                      <Col>
                        <Typography.Title level={5}>
                          Registration
                        </Typography.Title>
                      </Col>
                      <Col>
                        Already Registered?{" "}
                        <StyledLink
                          data-testid="submit-signin"
                          onClick={() => history.push("/login")}
                        >
                          Sign In
                        </StyledLink>
                      </Col>
                    </Row>
                    <Row>
                      <Col>
                        <Typography.Paragraph>
                          Search and apply for the job based on your competence
                        </Typography.Paragraph>
                      </Col>
                    </Row>
                    <Row justify="space-between" style={{ marginTop: "2vh" }}>
                      <Col>
                        <GoogleLogInButton
                          clientId={process.env.REACT_APP_GOOGLE_SIGN_UP}
                          onSuccess={responseGoogle}
                          onFailure={responseGoogle}
                        ></GoogleLogInButton>
                      </Col>
                      <Col>
                        <LinkedInButton
                          responseLinkedIn={responseLinkedIn}
                        ></LinkedInButton>
                      </Col>
                    </Row>
                    <Row style={{ marginTop: "3vh" }}>
                      <Col xs={{ span: 24 }}>
                        <Formik
                          initialValues={initialValues}
                          validateOnMount
                          validationSchema={validationSchema}
                          onSubmit={registerUser}
                        >
                          {(formik) => {
                            return (
                              <Form>
                                <Row justify="space-between">
                                  <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                    <FormikInput
                                      id="firstName"
                                      label="First Name"
                                      name="firstName"
                                      placeholder="Enter First name"
                                    ></FormikInput>
                                  </Col>
                                  <Col xs={{ span: 24 }} md={{ span: 11 }}>
                                    <FormikInput
                                      id="lastName"
                                      label="Last Name"
                                      name="lastName"
                                      placeholder="Enter Last name"
                                    ></FormikInput>
                                  </Col>
                                </Row>
                                <Col xs={{ span: 24 }}>
                                  <FormikEmailInput
                                    name="email"
                                    prefix={true}
                                  />
                                </Col>
                                <Col xs={{ span: 24 }}>
                                  <FormikPassword
                                    name="password"
                                    icon={true}
                                    suffix={true}
                                  />
                                </Col>
                                <Col xs={{ span: 24 }}>
                                  <SelectCountry
                                    id="selectCountry"
                                    label="Select Country"
                                    name="country"
                                    placeholder="Select Country"
                                    getCountryCode={getCountryCode}
                                  />
                                </Col>
                                <Col xs={{ span: 24 }}>
                                  <FormikInput
                                    id="mobileNumber"
                                    label="Mobile Number"
                                    name="mobileNumber"
                                    type="number"
                                    placeholder="Enter Mobile Number"
                                    prefix={countryCode}
                                  ></FormikInput>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                  <FormItem name="termsAndConditions">
                                    <Checkbox
                                      name="termsAndConditions"
                                      data-testid="termsAndConditions"
                                    >
                                      I accept{" "}
                                      <StyledLink>
                                        terms and conditions
                                      </StyledLink>
                                    </Checkbox>
                                  </FormItem>
                                </Col>
                                <Col xs={{ span: 24 }}>
                                  <FormItem name="marketingOptIn">
                                    <Checkbox
                                      name="marketingOptIn"
                                      data-testid="marketingOptIn"
                                    >
                                      Send the updates on WhatsApp or Telegram
                                    </Checkbox>
                                  </FormItem>
                                </Col>
                                {/* Implement Captcha */}
                                <Col xs={{ span: 24 }}>
                                  <FormikSubmitButton
                                    id="submit-register"
                                    name="Register"
                                    disabled={!formik.isValid}
                                  ></FormikSubmitButton>
                                </Col>
                              </Form>
                            );
                          }}
                        </Formik>
                      </Col>
                    </Row>
                  </Col>
                </Col>
              )}
            </Col>
          )}
        </Col>
      </Row>
    </Col>
  );
};

const GoogleLogInButton = (props) => {
  const { signIn } = useGoogleLogin({
    onSuccess: props.onSuccess,
    onFailure: props.onFailure,
    clientId: props.clientId,
  });
  return (
    <SocialButton onClick={signIn} data-testid="google-submit-login">
      <img
        style={{ float: "left" }}
        src={google}
        height="30px"
        alt="google-login"
      ></img>
      Sign In with Google
    </SocialButton>
  );
};

const LinkedInButton = (props) => {
  return (
    <SocialButton
      onClick={props.responseLinkedIn}
      data-testid="linkedin-submit-login"
    >
      <img
        style={{ float: "left" }}
        src={linkedIn}
        height="30px"
        alt="linkedin-login"
      ></img>
      Sign In with Linkedin
    </SocialButton>
  );
};

const mapStateToProps = (state) => ({
  isRegistered: state.consultantStore.isRegistered,
});

const mapDispatchToProps = (dispatch) => {
  return {
    signUpConsultant: (consultantDetails) =>
      dispatch(consultantReducer.signUpConsultant(consultantDetails)),
    googleAuthentication: (token, role) =>
      dispatch(googleAuthentication(token, role)),
    getLinkedInAcessToken: (redirectUri, accessCode, role) =>
      dispatch(getLinkedInAcessToken(redirectUri, accessCode, role)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(RegistrationForm);
